import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './RenderTBD.module.scss'

const RenderTBD = ({ status, size, layout }: any) => {
  const { t } = useTranslation()

  const isColumn = layout === 'column'

  if (size === 'big') {
    return (
      <div
        className={clsx(styles['lg-date'], {
          [styles['lg-date--column']]: isColumn,
        })}
      >
        <span
          className={clsx(styles['lg-date__label'], {
            [styles['lg-date__label--column']]: isColumn,
          })}
        >
          {t(`countdown.label.tbd.${status}`)}
        </span>

        <span
          className={clsx(styles['lg-date__label'], {
            [styles['lg-date__label--column']]: isColumn,
          })}
        >
          {t('countdown.time.TBD')}
        </span>
      </div>
    )
  }

  return (
    <div className={styles['container']}>
      <div className={styles['default-label']}>{t(`countdown.label.${status}`)}</div>
      <div className={styles['default-value']}>{t('countdown.time.TBD')}</div>
    </div>
  )
}
export default RenderTBD
